export default __webpack_public_path__ + "static/media/2.519a8442.webp";